import api from "../api";

export const GetContactForAccount = async (accountId: any) => {
	const res = await api.post("/get_contacts_for_account", {
		accountId,
		pod_user_id: Number(localStorage.getItem("podUserId")),
	});
	return res.data.data;
};
